<template>
  <div>
    <div class="hidden">{{ countryCode }}</div>
    <div
      v-if="view === 'loading'"
      class="z-10 flex items-center justify-center bg-white h-screen-height-no-mainheader t3m-Spinner"
    >
      <div
        class="w-12 h-12 border-t-2 rounded-full animate-spin border-primary text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <transition appear leave name="fade">
      <div
        class="t3m-ObjectiveFinder"
        :class="`t3m-ObjectiveFinder--${view}`"
        v-if="view != 'loading'"
        style="animation-duration: 2s"
      >
        <div class="container relative t3m-con-p-default">
          <div class="lg:grid lg:grid-cols-12 t3m-con-gut-default">
            <div v-if="view === 'list'" class="t3m-con-column-1 lg:col-span-3">
              <logo />
              <filter-panel />
            </div>

            <div
              class="t3m-con-column-2"
              :class="{
                'lg:col-span-9': view === 'list',
                'lg:col-span-12': view === 'compare',
              }"
              v-if="objectivesData"
            >
              <objective-list-header />
              <Banner v-show="view === 'list' && showBanner" />
              <objective-list v-if="view === 'list'" />
              <objective-comparison v-if="view === 'compare'" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { utilities } from './shared'
import { mapState } from 'vuex'
import FilterPanel from './components/FilterPanel.vue'
import ObjectiveListHeader from './components/ObjectiveListHeader.vue'
import ObjectiveList from './components/ObjectiveList.vue'
import ObjectiveComparison from './components/ObjectiveComparison.vue'
import Logo from './components/Logo.vue'
import Banner from './components/Banner.vue'

export default {
  name: 'App',
  data() {
    return {
      objectivesData: {},
    }
  },
  components: {
    FilterPanel,
    ObjectiveListHeader,
    ObjectiveList,
    ObjectiveComparison,
    Logo,
    Banner
  },
  computed: {
    ...mapState(['view', 'countryCode', 'showBanner']),
  },
  mixins: [utilities],
  mounted() {
    this.$store.dispatch('loadAllData')
    this.registerGsapPlugins()
  },
  methods: {},
}
</script>
